import gql from 'graphql-tag';

const GET_HELP_CENTER_ARTICLES = gql`
  query helpCenterArticles($feature: String!) {
    helpCenterArticles(where: { feature: $feature }, orderBy: sortOrder_ASC) {
      id
      feature
      requiredAction
      sectionId
      title
      icon
      content
      sortOrder
    }
  }
`;

export default GET_HELP_CENTER_ARTICLES;
